var exports = {
  "N": "MentionTooltipContent.module__card___c05NUE",
};

module.exports = exports;
